import React from 'react'
import { useLoginFlow } from '@ztechapps/common.hook'
import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'

export default function LoginSuccess() {
  const { redirect, accessToken } = useLoginFlow()

  //so it should be redirected to OAuth Authentication (even the user is already login)
  React.useEffect(() => {
    if (!accessToken) return
    return redirect()
  }, [accessToken])

  return (
    <CenterScreen>
      <LoadingContent message="Authenticating....." />
    </CenterScreen>
  )
}
